<template>
  <div
    class="mx-auto mt-auto mb-6 w-60 rounded-2xl px-4 py-5 bg-semantic-surface-container-high hidden lg:block"
  >
    <V2AtomsLabel>NEW</V2AtomsLabel>
    <h3 class="my-2 font-semibold text-semantic-surface-on-surface">Get the App Today</h3>
    <p class="mb-4 text-sm text-semantic-surface-on-surface">
      Manage your bills and save money on the go with our <br/>easy-to-use mobile app.
    </p>
    <div class="py-2 flex justify-center">
      <NuxtImg
        :src="`${APP_ASSET_BASEURL}clubplus/assets/qr_code/qr_code_dashboard_sidebar.png`"
        alt="QR Code"
        class="w-32 h-32 object-cover rounded-md"
      />
    </div>
    <!-- <nuxt-link
      to="/dashboard/app/"
      target="_blank"
      rel="nofollow"
      class="flex items-center justify-center p-3 font-medium text-white rounded-lg text-sm hover:bg-semantic-primary-variant-highlight text-semantic-primary-default bg-semantic-primary-variant-dark border-semantic-primary-default"
    >
      Install now
    </nuxt-link> -->
  </div>
</template>
